
export const dnaServices = [
  {
    title: "Legal Paternity Testing",
    description: "Court-admissible paternity testing with proper chain of custody documentation."
  },
  {
    title: "Non-Legal Paternity Testing",
    description: "Peace of mind paternity testing for personal knowledge only."
  },
  {
    title: "Prenatal Paternity Testing",
    description: "Non-invasive prenatal paternity testing available from 8 weeks gestation."
  },
  {
    title: "Call us",
    description: "AABB-accredited testing for immigration and visa applications."
  },
  {
    title: "Grandparentage Testing",
    description: "Establish biological relationships with grandparents when father is unavailable."
  },
  {
    title: "Sibling DNA Testing",
    description: "Determine if individuals share one or both biological parents."
  }
];

export const genderRevealServices = [
  {
    title: "Peekaboo Early Gender Test",
    description: "Determine baby's gender as early as 6 weeks with 99.9% accuracy."
  },
  {
    title: "Peekaboo Rush Results",
    description: "Get your gender results in just 1-2 business days."
  }
];

export const legalServices = [
  {
    title: "Court-Ordered Testing",
    description: "Legally admissible testing for family court proceedings."
  },
  {
    title: "Child Support Cases",
    description: "Paternity testing for child support establishment."
  },
  {
    title: "Custody Disputes",
    description: "DNA testing for child custody and visitation cases."
  }
];

export const drugTestingServices = [
  {
    title: "DOT Drug Testing",
    description: "Department of Transportation compliant drug screening."
  },
  {
    title: "Non-DOT Drug Testing",
    description: "Comprehensive workplace drug testing solutions."
  },
  {
    title: "Pre-Employment Screening",
    description: "Complete background and drug screening packages."
  }
];

export const landlordServices = [
  {
    title: "Background and Credit Checks",
    description: "Background checks for potential tenants."
  },
  {
    title: "Rental Application Verification",
    description: "Employment and income verification for rental applications."
  }
];

export const phlebotomyServices = [
  {
    title: "Routine Blood Draws",
    description: "Professional blood collection for 1-6 tubes with proper handling."
  },
  {
    title: "Wellness & Preventive Panels",
    description: "Complete health screening and wellness blood work."
  },
  {
    title: "Physician-Ordered Tests",
    description: "Collection for Quest, LabCorp, Ulta, and other specialty kits."
  },
  {
    title: "Mobile Drug & Nicotine Testing",
    description: "On-site drug screening with immediate collection."
  },
  {
    title: "Insurance & Pre-Employment",
    description: "Collections for employment and insurance requirements."
  },
  {
    title: "Home-Bound Patient Care",
    description: "Post-surgical and mobility-limited patient blood draws."
  }
];

// NearLab Services pricing structure (DNA testing only)
export const nearlabPricing = {
  dna: {
    legalPaternity: { price: 365, time: "1-3 business days" },
    nonLegalPaternity: { price: 265, time: "1-3 business days" },
    prenatalPaternity: { price: "Call us", time: "7-10 business days" },
    immigration: { price: "Call us", time: "3-5 business days" },
    grandparentage: { price: 435, time: "5-7 business days" },
    sibling: { price: 435, time: "5-7 business days" },
    avuncular: { price: 395, time: "5-7 business days" },
    maternal: { price: 295, time: "3-5 business days" },
    yChromosome: { price: 395, time: "7-10 business days" }
  },
  genderReveal: {
    earlyPeekaboo: { price: 122, time: "3-5 business days" },
    rushPeekaboo: { price: 199, time: "1-2 business days" }
  },
  additionalServices: {
    mobileCollection: { price: 150, description: "On-site sample collection" },
    rushProcessing: { price: 200, description: "24-hour processing" },
    additionalParticipant: { price: 150, description: "Each additional person tested" },
    retest: { price: 100, description: "Retest of existing sample" }
  },
  phlebotomy: {
    routineBloodDraw: { 
      mobile: 50, 
      inOffice: 30, 
      description: "1-3 tubes" 
    },
    specialtyCollection: { 
      mobile: "65-85", 
      inOffice: 45, 
      description: "Specialty/Kit collection" 
    },
    statAfterHours: { 
      mobile: 25, 
      inOffice: 15, 
      description: "Additional fee for STAT/after hours" 
    },
    specimenDropOff: { 
      mobile: 20, 
      inOffice: 10, 
      description: "Quest/LabCorp drop-off" 
    },
  }
};
